import { Injectable, TemplateRef } from '@angular/core';
import {} from '../_helpers/toast/toast-container.component'


@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];
  iconName: string;

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  showStandard(message) {
    this.show(message);
  }

  showSuccess(message) {
    this.iconName = "check_circle";
    this.show(message, { classname: 'bg-success text-light', delay: 3000 , autohide: true });
  }

  showDanger(dangerTpl) {
    this.iconName = "highlight_off";
    var _dangerTpl = dangerTpl.toString().replace(/\[(.*?)]/g, "");
    var teste = _dangerTpl.split("!");
    teste.map(item => {
      if (item.length > 0) {
        this.show(item + ".", { classname: 'bg-danger text-light', delay: 3000, autohide: true });
      }
    });
}

  showDangerWithHeader(textHeader, text) {
    this.show(text, { classname: 'bg-danger text-dark with-header', delay: 3000, withHeader: true, headerText: textHeader,autohide: true });
  }
}
